export enum OnboardingStatus {
  NaoIniciado = 0,
  Beneficios = 1,
  Empresa = 2,
  Contrato = 3,
  Beneficiarios = 4,
  Finalizado = 5,
}
